import React, { Suspense, useEffect, useState } from 'react';
import styles from './index.less';
import { Modal, Badge, Card } from 'antd';

import DF from 'DisplayFramework';
import HeaderDropdown from '../HeaderDropdown';
import Simul from 'pages/ProposalV3/PropDetail';
import SIDetail from 'pages/SupplierInvoice/SIDetail';
import ThirdPartyDetail from 'pages/ThirdParty/ThirdPartyDetail';
import GetLabel from 'DisplayFramework/components/GetLabel';
import IQuickActions from 'icons/IQuickActions';
import { getProcInitHome } from 'services/workflow';
import AssetDetails from 'pages/Asset/AssetDetail';
import CIDetail from 'pages/ClientInvoice/CIDetail';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';

const QuickLinks = () => {
  const { getComponentConfiguration } = useDisplayFrameworkContext();

  const [listNewProc, setListNewProc] = useState([]);
  const [visibleModal, setVisibleModal] = useState(false);
  const [titleModal, setTitleModal] = useState('');
  const [ModuleModal, setModuleModal] = useState('');
  const [taskid, setTaskid] = useState(0);

  useEffect(() => {
    loadNewProc();
  }, []);

  const loadNewProc = () => {
    getProcInitHome().then((response:any) => {
      setListNewProc(response?.list);
    });
  };

  const showModal = (title:any, proccode:any, taskId:any, lmodule:any) => {
    setTitleModal(title);
    setModuleModal(lmodule);
    setTaskid(taskId);
    setVisibleModal(true);
  };

  const handleOkModal = () => {
    setVisibleModal(false);
  };

  const handleCancelModal = () => {
    setVisibleModal(false);
  };

  const quickActionDropdown = (
    <Suspense fallback={null}>
      <Card title={<GetLabel label="New procedures" />}>
        {listNewProc?.map((item:any) => (
          <li key={item.taskid}>
            <Badge status="success" />
            <a
              onClick={(e) => {
                e.stopPropagation();
                showModal(
                  item.tasklabel,
                  item.proccode,
                  item.taskid,
                  item.procmodule
                );
              }}
            >
              {item.tasklabel}
            </a>
          </li>
        ))}
      </Card>
    </Suspense>
  );

  const compHide = (comcode:any) => {
    let comp = getComponentConfiguration(comcode);
    return comp?.flaghide ?? false;
  };
  return (
    <DF.Provider pagcode="welcome">
      {!compHide('quickAction') && (
        <HeaderDropdown
          overlay={quickActionDropdown}
          overlayClassName={undefined}
        >
          <span className={`${styles.action} ${styles.account}`}>
            <IQuickActions />
            <span className={styles.name}>
              <GetLabel
                label="quickAction"
                Inspectstyle={{ marginTop: '15px' }}
              />
            </span>
          </span>
        </HeaderDropdown>
      )}

      <Modal
        title={titleModal}
        visible={visibleModal}
        footer={null}
        onOk={handleOkModal}
        onCancel={handleCancelModal}
        width="90%"
        style={{ top: 20 }}
      >
        {ModuleModal === 'PROPOSAL' && (
          <Simul
            setisvisible={handleOkModal}
            isModal
          />
        )}
        {ModuleModal === 'THIRDPARTY' && (
          <ThirdPartyDetail
            taskid={taskid}
            setisvisible={handleOkModal}
            isModal
          />
        )}
        {ModuleModal === 'SINVOICE' && <SIDetail isCreateSI />}
        {ModuleModal === 'ASSET' && (
          <AssetDetails
            setisvisible={handleOkModal}
            phaseprop='PROPOSAL'
          />
        )}
        {ModuleModal === 'CINVOICE' && <CIDetail isCreateCI />}
      </Modal>
    </DF.Provider>
  );
};

export default QuickLinks;

